import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import NewIncomingBalance from '@/incoming-balance/NewIncomingBalance.vue'

export const INCOMING_BALANCE = {
    componentName: 'IncomingBalance',
    component: NewIncomingBalance
}

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

const icon = 'i-ph-download-simple'
const label = 'Inngående balanse'

registerNavigationCommand({
    route: INCOMING_BALANCE,
    label,
    icon,
})
registerNavigationEntry(NavGroup.IMPORTS, {
    title: label,
    key: 'incoming-balance',
    icon,
    target: INCOMING_BALANCE,
    sortOrder: 0,
})
registerRoute(INCOMING_BALANCE)
buildSimpleCrumb(INCOMING_BALANCE, label, icon)